"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.description.placeholder': 'Inserisci descrizione della conoscenza',
};
